export default (params) => ({
  trigger: {
    name: 'content_blocks.faq.select_all_faq',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'select_all',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
